{
  "colorInputLabel": "{label}, {channelLabel}",
  "colorNameAndValue": "{name}: {value}",
  "colorPicker": "Kleurkiezer",
  "twoDimensionalSlider": "2D-schuifregelaar",
  "colorSwatch": "color swatch",
  "transparent": "transparent"
}
